import { useState, type ReactNode } from 'react';
import { ThemeContext, type Theme } from './theme-context';

const THEME_STORAGE_KEY = 'dt-pm-theme';

function initialTheme(): Theme {
  try {
    const saved = localStorage.getItem(THEME_STORAGE_KEY);
    if (saved === 'dark') return 'dark-blue';
    if (saved === 'light' || saved === 'dark-blue' || saved === 'dark-purple') return saved;
  } catch {
    // Storage may be unavailable in private browsing.
  }
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark-blue' : 'light';
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setThemeState] = useState<Theme>(() => {
    const current = initialTheme();
    document.documentElement.dataset.theme = current;
    return current;
  });

  function setTheme(next: Theme) {
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem(THEME_STORAGE_KEY, next);
    } catch {
      // The theme still applies for this session.
    }
    setThemeState(next);
  }

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
}
